import React, { ReactElement, useEffect } from "react";
import Head from "next/head";
import { observer } from "mobx-react";
import PageContainer from "common/PageContainer/PageContainer";
import BrowsingHistory from "common/BrowsingHistory/BrowsingHistory";
import PopularCategories from "common/PopularCategories/PopularCategories";
import { useStore } from "store";
import Placeholder404 from "./components/Placeholder404/Placeholder404";

import styles from "./404.module.scss";

const Page404: React.FC = (): ReactElement => {
  const { categories } = useStore();

  useEffect(() => {
    if (categories.list.length) return;

    categories.fetch();
  }, [categories]);

  return (
    <PageContainer>
      <Head>
        <title>Страница не найдена — 404 Not Found</title>
        <meta
          name="description"
          content="Запрашиваемая страница не найдена на нашем сайте, воспользуйтесь навигацией, поиском по сайту или посмотрите ранее просмотренные товары."
        />
      </Head>
      <div className={styles.layout}>
        <Placeholder404 />
        {!!categories.list.length && (
          <PopularCategories categories={categories.list.slice(0, 4)} />
        )}
        <BrowsingHistory className={styles.browserHistory} />
      </div>
    </PageContainer>
  );
};

export default observer(Page404);
